<template>
  <div id="app">
    <!-- 路由容器：根据 Home.vue 逻辑区分布局 -->
    <router-view :key="$route.fullPath"></router-view>
    
    <!-- 企业微信移动端底部导航（仅在非登录页+移动端显示） -->
    <div 
      class="wxwork-footer-nav" 
      v-if="isShowMobileFooter"
    >
      <router-link to="/tasks" class="nav-item">
        <i class="el-icon-menu"></i>
        <span>任务列表</span>
      </router-link>
      <router-link to="/task/create" class="nav-item">
        <i class="el-icon-plus"></i>
        <span>任务创建</span>
      </router-link>
      <router-link to="/report/reportData" class="nav-item">
        <i class="el-icon-s-data"></i>
        <span>报表查看</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { isWxWorkEnv } from '@/utils/request';

export default {
  name: 'App',
  data() {
    return {
      isShowMobileFooter: false
    };
  },
  watch: {
    // 监听路由变化，动态控制底部导航显示
    $route: {
      immediate: true,
      handler(route) {
        // 仅在 企业微信移动端 + 非登录页 显示底部导航
        const isWxWorkMobile = isWxWorkEnv() && /mobile/i.test(navigator.userAgent);
        const isNotLoginPage = route.name !== 'Login';
        this.isShowMobileFooter = isWxWorkMobile && isNotLoginPage;
      }
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

/* 企业微信移动端底部导航（适配 Home.vue 移动端样式） */
.wxwork-footer-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #fff;
  border-top: 1px solid #e5e6eb;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 999;
}
.nav-item {
  color: #333;
  text-decoration: none;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: color 0.2s;
}
.nav-item:hover,
.nav-item.router-link-active {
  color: #2d8cf0; /* 与 Home.vue 视觉统一 */
}
.nav-item i {
  font-size: 20px;
  margin-bottom: 4px;
}

/* 兼容 Home.vue 的 Element UI 样式 */
.el-header, .el-footer {
  text-align: center;
  line-height: 60px;
}
.el-aside {
  color: #333;
}
.wxwork-mobile {
  height: 100%;
  overflow-y: auto;
  /* 给底部导航预留空间，避免内容被遮挡 */
  padding-bottom: 70px !important; 
  box-sizing: border-box;
}

/* 移动端内容区域：重点修复遮挡问题 */
.wxwork-mobile .home-content {
  padding: 10px !important;
  background-color: #fff !important;
  /* 关键：增加底部内边距，适配底部导航高度 */
  padding-bottom: 80px !important; 
  /* 确保内容可滚动 */
  height: calc(100vh - 10px) !important;
  box-sizing: border-box;
}

.wxwork-mobile .content-card {
  box-shadow: none !important;
  border: none !important;
  /* 卡片高度铺满，且可滚动 */
  height: 100% !important;
  overflow-y: auto;
}
</style>